const env = import.meta.env

const AMPLITUDE_API_KEY = env.VITE_AMPLITUDE_API_KEY
const AMPLITUDE_EXPERIMENTS_DEPLOY_KEY = env.VITE_AMPLITUDE_EXPERIMENTS_DEPLOY_KEY
const ENV = env.VITE_ENV
const AWS_COMMIT_ID = env.VITE_AWS_COMMIT_ID
const GOOGLE_ANALYTICS_ID = env.VITE_GOOGLE_ANALYTICS_ID
const API_URL_AU = env.VITE_API_URL_AU
const API_URL_US = env.VITE_API_URL_US
const API_URL_AE = env.VITE_API_URL_AE
const API_URL_BR = env.VITE_API_URL_BR
const ALLOWED_PAYMENTMETHOD_CARD_FUNDING = env.VITE_ALLOWED_PAYMENTMETHOD_CARD_FUNDING
const COMMIT_REF = env.VITE_COMMIT_REF

if (!AMPLITUDE_API_KEY) {
	throw new Error("Environment variable AMPLITUDE_API_KEY is required for Amplitude initialization.")
}

if (!AMPLITUDE_EXPERIMENTS_DEPLOY_KEY) {
	throw new Error(
		"Environment variable AMPLITUDE_EXPERIMENTS_DEPLOY_KEY is required for Amplitude Experiments initialization.",
	)
}

export {
	AMPLITUDE_API_KEY,
	AMPLITUDE_EXPERIMENTS_DEPLOY_KEY,
	ENV,
	AWS_COMMIT_ID,
	GOOGLE_ANALYTICS_ID,
	API_URL_AU,
	API_URL_US,
	API_URL_AE,
	API_URL_BR,
	ALLOWED_PAYMENTMETHOD_CARD_FUNDING,
	COMMIT_REF,
}
